export default __webpack_public_path__ + "static/media/evas01.8283d3d1.jpg";